import { useEffect } from 'react'
import { CheckArabicText, CheckEnglishText } from '../../../utils'
import "./style.css"
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { Block, Inline } from '@comp/crRender'

const TextArea = ({ label, value = "",isError , setValue, defaultValue = "", className, lang = "Ar", isRequired = false }) => {
    const { t } = useTranslation()

    const [inputClassName, setInputClassName] = useState("")

    useEffect(() => {
        handleValue(defaultValue || "")
    }, [defaultValue])

    const handleValue = (value) => {

        if (lang == "Ar" || (value == "" && lang != 'En')) {
            if (CheckArabicText(value) || value == "") {
                setValue(value)
                setInputClassName("")
            } else {
                setInputClassName("value-error")
            }
        }

        if (lang == "En" || (value == "" && lang != 'Ar')) {
            if (CheckEnglishText(value) || value == "") {
                setValue(value)
                setInputClassName("")
            } else {
                setInputClassName("value-error")
            }
        }
    }


    return (
        <div className={`text-container ${className} ${inputClassName}`}>
            <Block isRender={label} className={"col-sm-12 default-label"} >
                <span> {t(label)} </span>
                <Inline isRender={isRequired} className={"required"}>*</Inline>
            </Block>
            <textarea className={`text-area col-12 ${isError ? "field-required" :""}`} value={value} onChange={e => handleValue(e.target.value)} ></textarea>
        </div >
    )
}

export default TextArea